import React from 'react'

interface ListToolbarSectionIconProps {
  size?: number
  className?: string
}

/**
 * Der **Abschnitt** der Listen-Werkzeug-Pille (Figma `Icon /
 * AlignVerticalJustifyCenter` in 5550:75620). Zweifarbig und hart kodiert wie
 * `CanvasNoteIcon` — Grün gehört dem Abschnitt, nicht dem Theme.
 *
 * Die Teil-Klassen tragen die Bewegung beim Überfahren (#315, `_toolbarIconMotion.scss`).
 */
export const ListToolbarSectionIcon: React.FC<ListToolbarSectionIconProps> = ({ size = 24, className }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={['list-toolbar-section-icon', className].filter(Boolean).join(' ')} aria-hidden="true">
    <path className="list-toolbar-section-icon__bottom" d="M17 16H7C5.89543 16 5 16.8954 5 18V20C5 21.1046 5.89543 22 7 22H17C18.1046 22 19 21.1046 19 20V18C19 16.8954 18.1046 16 17 16Z" fill="#D8F8E8" stroke="#31A569" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path className="list-toolbar-section-icon__line" d="M2 12H22" stroke="#31A569" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path className="list-toolbar-section-icon__top" d="M17 2H7C5.89543 2 5 2.89543 5 4V6C5 7.10457 5.89543 8 7 8H17C18.1046 8 19 7.10457 19 6V4C19 2.89543 18.1046 2 17 2Z" fill="#D8F8E8" stroke="#31A569" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)
